import type {EmailReviewContext} from '@/pinia/createBooking';

const key = (userId: number) => `pending-email-review-booking:${userId}`;
export const savePendingEmailReview = (userId: number, context: EmailReviewContext): void => {
  sessionStorage.setItem(key(userId), JSON.stringify(context));
};
export const takePendingEmailReview = (userId: number): EmailReviewContext | null => {
  const storageKey = key(userId);
  const raw = sessionStorage.getItem(storageKey);
  if (!raw) return null;
  sessionStorage.removeItem(storageKey);
  try { return JSON.parse(raw) as EmailReviewContext; } catch (_) { return null; }
};
export const clearPendingEmailReview = (userId?: number): void => {
  if (userId) sessionStorage.removeItem(key(userId));
};
